export const ANNOTATION_TYPES = [
	'manuscript',
	'text',
	'date',
	'full_name',
	'initials',
] as const;

/**
 * A placed field. x/y/width/height are only meaningful relative to containerRect:
 * new annotations store 96-dpi base px of the page with containerRect = the page's
 * base size; older stored ones hold browser px with the rendered page rect. Read
 * them through annotation-geometry.ts, never as absolute px.
 */
export type Annotation = {
	id: string;
	page: number;
	x: number;
	y: number;
	width: number;
	height: number;
	containerRect: {
		width: number;
		height: number;
	};
	type: (typeof ANNOTATION_TYPES)[number];
	email: string;
	value?: string;
};

export const DEFAULT_DIMENSIONS = {
	WIDTH: 150,
	HEIGHT: 50,
};
